import { RobotOutlined } from '@ant-design/icons';
import { VerificaDocumentoAI } from '@framework/api-client';
import { useTranslation } from '@framework/i18n';
import { FlexRow, PercentageFormatter } from '@framework/ui';
import { Space, Tooltip } from 'antd';
import { isEmpty } from 'lodash';
import { darken } from 'polished';
import styled from 'styled-components';
import { AiMessageText } from './message/AiMessageText';

const AiFileCheckWrapper = styled.div`
  padding: 0px 4px;
  /* margin-top: 16px; */
  border-radius: 4px;
  padding-left: 0;
  /* padding: 4px 10px; */
  background-color: ${props => props.theme.colorWarningBg};
  border: 1px solid ${props => props.theme.colorWarning};
  color: ${props => props.theme.colorWarningActive};
  &.success {
    background-color: ${props => props.theme.colorSuccessBg};
    border: 2px solid ${props => props.theme.colorSuccess};
    color: ${props => darken(0.1, props.theme.colorSuccessActive)};
  }
`;

const AiFileCheckIcon = styled.div`
  background-color: ${props => props.theme.colorWarning};
  color: white;
  font-size: 14px;
  line-height: 1;
  height: 22px;
  width: 23px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const AiFileCheckMessageContainer = styled.div`
  color: ${props => darken(0.1, props.theme.colorWarningActive)};
  font-size: 16px;
  line-height: 1.2;
`;

export enum EnumAiFileTypes {
  patente = 'patente',
  cie = 'cie',
  cartaIdentita = 'carta_identita',
  passaporto = 'passaporto',
}

export interface IAiFileCheckMessageProps {
  // la verifica della firma al momento non è possibile
  // signatureResult?: typeof fixturesAiModuleCheckResponse;
  result?: VerificaDocumentoAI;
  isBackoffice?: boolean;
  isReadonly?: boolean;
}
/**
 * Messaggio di verifica Documenti con AI (solo Documenti)
 */
export function AiFileCheckMessage(props: IAiFileCheckMessageProps) {
  const { result, isBackoffice, isReadonly } = props;
  const { t } = useTranslation();

  if (isEmpty(result)) return null;

  // creiamo i messaggi da mostrare in base al risultato
  const success = result.flag_identification;
  const identificationScore = isBackoffice
    ? `(Punteggio: ${PercentageFormatter.format(result.score ?? 0)})`
    : '';
  const frontMessage = {
    notIdentification: t(
      'ai-file-check-message.warning.not-identification',
      'Il tipo documento non sembra corretto.',
    ),
  };
  // nel backoffice mostriamo le traduzioni
  const messages = {
    notIdentification: `${frontMessage.notIdentification} ${identificationScore}`,
    identification: `Il tipo documento è corretto. ${identificationScore}`,
  };

  // se il documento è corretto e non siamo nel backoffice, non mostriamo nulla
  if (success && !isBackoffice) {
    return null;
  }

  return (
    <AiFileCheckWrapper>
      <Tooltip
        color={'#0066cc'}
        // nel backoffice non mostriamo il tooltips
        open={isBackoffice || isReadonly ? false : undefined}
        title={
          <Space>
            <div style={{ fontSize: 24 }}>
              <RobotOutlined />
            </div>
            {t(
              'ai-file-check-message.tooltip.suggestions',
              'Puoi comunque procedere oppure ricaricare il documento.',
            )}
          </Space>
        }
      >
        <FlexRow
          gutter={6}
          align="center"
          left={
            <AiFileCheckIcon>
              <RobotOutlined />
            </AiFileCheckIcon>
          }
        >
          <AiFileCheckMessageContainer>
            <AiMessageText
              isBackoffice={isBackoffice}
              success={result.flag_identification ?? false}
              warningText={messages.notIdentification}
              successText={messages.identification}
            />
          </AiFileCheckMessageContainer>
        </FlexRow>
      </Tooltip>
    </AiFileCheckWrapper>
  );
}
